import React, { useEffect, useRef } from 'react';
import { AdMarketplaceSlotDivNames } from './ad-slots';
import { AdMarketplaceLoader } from './client-side/loader';
import './styles.scss';


export type AdMarketplaceAdsProps = {
    pageType: string | undefined;
    l1Category: string | undefined;
    device: string | undefined;
    currentPage: number | undefined;
    isZeroResults: boolean;
    query?: string;
    isQA?: boolean;
    resultsTa?: number;
    resultsPa?: number;
    locale?: string;
    style?: React.CSSProperties;
    slot: string;
};

const AdMarketplaceAds: React.FC<AdMarketplaceAdsProps> = ({
    slot,
    pageType,
    l1Category,
    device,
    currentPage,
    isZeroResults,
    query,
    resultsTa,
    resultsPa,
    locale,
    style,
    isQA,
}) => {
    const mountedRef = useRef(false);
    const getKeyword = () => {
        if (pageType === 'ResultsBrowse' || pageType === 'ResultsSearch') {
            return query || 'for sale';
        }
        if (l1Category) {
            return String(l1Category).toLowerCase();
        }
        return 'for sale';
    }

    useEffect(() => {
        if (mountedRef.current) return;
        if (typeof window === 'undefined') return;

        const configDev = {
            'partnerName': 'demofeed',
            'plid': '98b3yhdrl7',
            'qt': 'shoes',
            'v': '2.0',
            'rfr': 'https://sitename.com/searchterm',
            resultsTa,
            resultsPa,
            // 'ip': '94.4.42.244',  // demo param
        }
        const configProd = {
            'partnerName': 'gumtree',
            'plid': '',
            'qt': getKeyword(),
            'v': '2.0',
            resultsTa,
            resultsPa,
            'rfr': window.location.href,
        }
        const config = isQA ? configDev : configProd;

        const loader = new AdMarketplaceLoader(config);
        loader.loadAds(config.qt, slot).catch((e) => console.error('AdMarketplace: load error', e));

        mountedRef.current = true;
    }, [pageType, l1Category, currentPage, device, isZeroResults, query, resultsTa, resultsPa, locale]);

    return (
        <div id={slot} className="admarketplace-root" style={{ minHeight: '250px', ...style }}>
            {/* <div id={AdMarketplaceSlotDivNames.textAdContainer} /> */}
            <div id={AdMarketplaceSlotDivNames.productAdContainer} />
        </div>
    );
};

export default AdMarketplaceAds;


